import React from "react"
import PropTypes from "prop-types"

class DownloadApp extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div className="wrapper_form_dark" style={{backgroundColor: '#01579B', margin: 'auto', textAlign: 'center', maxWidth: 400, marginBottom: 40}}>
      	<div className="form_section">
      		<h3>{`Download Lexody's beta app!`}</h3>
      	</div>
      	<div className="form_section">
      		<h5 style={{paddingBottom:24, fontSize: 16}}>Use the app while we develop it:</h5>

      		<div className="actions">
      			<div style={{justifyContent: 'space-around', display: 'flex'}}>
                <div onClick={() => window.location.assign("https://play.google.com/apps/testing/com.lexody.lexodyapp")}>
        					<button className="btn_primary" style={{maxWidth: 250, display: 'inline-block'}}>
        						<img src={this.props.androidLogo} style={{height: 30, width: 30}} />
                      <h5>Android</h5>
        					</button>
        				</div>

                <div onClick={() => window.location.assign("https://apps.apple.com/us/app/lexody/id1376288941")}>
                  <button className="btn_primary" style={{maxWidth: 250, display: 'inline-block'}}>
                    <img src={this.props.appleLogo} style={{height: 30, width: 30}} />
                      <h5>Apple</h5>
                  </button>
        				</div>
        			</div>
      		</div>
      	</div>
      	<div className="form_section">
      		<h5>*Subscriptions can only be managed through the web.</h5>
      	</div>
      </div>
    )
  }
}

export default DownloadApp;
